import React, { Component } from 'react'
import moment from 'moment'

import { AddressView } from './'

class EmployerView extends Component {

  render() {
    let employer = this.props.employerInfo;
    if (!employer) {
      return null;
    }
    return (

      <div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Организация</label>
              <div className="form-element-data date">
                <div className="form-element-data-text">
                  <p>{employer.organization}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Должность</label>
              <div className="form-element-data date">
                <div className="form-element-data-text">
                  <p>{employer.position}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-row">
          {employer.phone && <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Телефон</label>
              <div className="form-element-data date">
                <div className="form-element-data-text">
                  <p>{employer.phone}</p>
                </div>
              </div>
            </div>
          </div>}
          {employer.accountingPhone && <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Телефон бухгалтерии</label>
              <div className="form-element-data date">
                <div className="form-element-data-text">
                  <p>{employer.accountingPhone}</p>
                </div>
              </div>
            </div>
          </div>}
        </div>
        <div className="form-row">

          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">С</label>
              <div className="form-element-data date">
                <div className="form-element-data-text">
                  <p>{moment(employer.startDate).format("DD.MM.yyyy")}</p>
                </div>
              </div>
            </div>
          </div>
          {employer.endDate && <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">По</label>
              <div className="form-element-data date">
                <div className="form-element-data-text">
                  <p>{moment(employer.endDate).format("DD.MM.yyyy")}</p>
                </div>
              </div>
            </div>
          </div>}
        </div>
        <div className="content-section-title">
          <h3>Адрес</h3>
        </div>
        <AddressView addressInfo={employer.employerAddress} titleApartment={'Помещение'} isEmployer/>
      </div>
    )
  }
}

export default EmployerView
